(function (global) {
  "use strict";

  var aliases = {
    ups: "UPS",
    "united parcel service": "UPS",
    fedex: "FedEx",
    "federal express": "FedEx",
    usps: "USPS",
    "us postal service": "USPS",
    "united states postal service": "USPS",
    "dhl express": "DHL Express",
    "dhl ecommerce": "DHL eCommerce",
  };

  function compact(value) {
    return String(value || "")
      .replace(/\s+/g, "")
      .toUpperCase();
  }

  function suggest(trackingNumber) {
    var number = compact(trackingNumber);
    if (/^1Z[A-Z0-9]{16}$/.test(number)) return "UPS";
    if (/^(?:\d{12}|\d{15})$/.test(number)) return "FedEx";
    if (/^(?:9[2-5]\d{18,20}|[A-Z]{2}\d{9}US)$/.test(number)) return "USPS";
    if (/^\d{10}$/.test(number)) return "DHL Express";
    if (/^GM\d{16,22}$/.test(number)) return "DHL eCommerce";
    return "";
  }

  function normalize(value) {
    return (
      aliases[
        String(value || "")
          .trim()
          .toLowerCase()
      ] || ""
    );
  }

  global.BBTrackingCarriers = {
    options: ["UPS", "FedEx", "USPS", "DHL Express", "DHL eCommerce"],
    suggest: suggest,
    normalize: normalize,
  };
})(window);
